import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
  domainName,
  cycleRule
} from "../../../utility/index"
import {
  downLoadCarTemplateFile,
  exportCarXLXS
} from '../../../api/config/modules/VehicleFiles'
import moment from "moment";
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export default {
  name: 'VehicleFiles',
  components: {
    tree,
    iTable,
    IPagination
  },
  data() {
    return {
      isCollapse: false,
      stateArrow: true,
      isSearch: true,
      formInline: {
        selectCarType: '',
        selectCarValue: '',
        terminalId: '',
        // FactoryTime: [],
      },
      optionsInput: [{
        value: '0',
        label: this.$t('common.search.whole')
      }, {
        value: '1',
        label: this.$t('common.carId')
      }, {
        value: '2',
        label: this.$t('common.plateNum')
      }, {
        value: '3',
        label: this.$t('common.customNum')
      },
      {
        value: '4',
        label: this.$t('common.manufactureNum')
      },
      {
        value: '5',
        label: this.$t('common.registrationCode')
      }
      ],
      height: '550',
      list: [],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: false,
        serialNumber: true,
      },
      columns: [{
        prop: "carId",
        label: this.$t('common.carId'),
        align: "center",
        width: "150px"
      },
      {
        prop: "manufactureNum",
        label: this.$t('common.manufactureNum'),
        align: "center",
        width: "150px"
      },
      {
        prop: "carExpiresNum",
        label: this.$t('common.registrationCode'),
        align: "center",
        width: "150px"
      },
      {
        prop: "plateNum",
        label: this.$t('common.plateNum'),
        align: "center",
        width: "120px"
      },
      {
        prop: "terminalId",
        label: this.$t('TerminalFile.terminalId'),
        align: "center",
        width: "160px"
      },
      {
        prop: "terminalDate",
        label: this.$t('VehicleManagement.terminalBindDate'),
        align: "center",
        width: "160px"
      },
      {
        prop: "orgName",
        label: this.$t('common.orgName'),
        align: "center",
        width: "180px"
      },
      {
        prop: "linkState",
        label: this.$t('OTAManagement.state'),
        align: "center",
        width: "120px",
        render: (h, params) => {
          return h('el-tag', {
            props: {
              type: params.row.linkState === '' ? '' : params.row.linkState === 0 ? 'info' : 'success'
            }
          }, params.row.linkState === '' ? '' : params.row.linkState === 0 ? this.$t('common.offLine') : this.$t('common.onLine'))
        }
      },
      ],
      operates: {
        width: 160,
        fixed: "right",
        list: [{
          id: '1',
          show: true,
          // icon: 'iconfont icontupian',
          label: this.$t('VideoPreview.liveVideo'),
          plain: true,
          disabled: false,
          // isBtn: "VEHICLEANNUALREVIEW_PIC",
          method: (index, row) => {
            this.currentCarInfo = row
            this.diaTitle = this.$t('VideoPreview.liveVideo')
            // 先停止之前的播放器并重置状态
            if (this.videoPlayer || this.flvPlayer) {
              this.stopVideo()
            }
            this.videoStreamUrl = ''
            this.isPlaying = false
            this.isPaused = false
            this.showPlayButton = false
            // 每次打开弹框都重置到第一个 tab（DMS摄像头）
            this.activeName = '1'
            // 最后再打开弹框，确保状态已经重置
            this.$nextTick(() => {
              this.dialogFormVisible = true
            })
          }
        },
        {
          id: '2',
          show: true,
          label: this.$t('VideoPreview.historyVideo'),
          // icon: 'iconfont icontupian',
          plain: true,
          disabled: false,
          // isBtn: "VEHICLEANNUALREVIEW_PIC",
          method: (index, row) => {
            this.currentCarInfo = row;
            this.historyVideoDialogVisible = true;
          }
        }
        ],
      },
      currentPage: 1,
      pageSize: 10,
      total: 1,

      dialogFormVisible: false,
      formLabelWidth: '112px',
      diaTitle: '',
      btnType: '',
      activeName: '1',

      historyVideoDialogVisible: false,  // 历史视频弹框显示状态

      dialogTransferFormVisible: false,
      LabelWidth: '104px',

      id: '',
      name: '',

      currentCarInfo: null,
      videoStreamUrl: '',
      videoPlayer: null,
      flvPlayer: null,
      isFlvJsLoaded: false,
      isPlaying: false,  // 标记视频是否正在播放
      isPaused: false,   // 标记视频是否暂停
      showPlayButton: false,  // 控制播放按钮显示/隐藏
    }
  },
  created() {

  },
  beforeDestroy() {
    // 组件销毁前清理视频播放器
    this.destroyVideoPlayer()
  },
  methods: {
    toggleSideBar() {
      this.isCollapse = !this.isCollapse
      this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
    },
    changeArrow() {
      this.stateArrow = !this.stateArrow
    },
    initQuery(item) {
      this.id = item.id
      this.name = item.name
      this.getAllCar()
    },
    nodeClick(val) {
      this.id = val.label
      this.name = val.value
      this.getAllCar()
    },
    getAllCar() {
      // let startTime = ''
      // let endTime = ''
      // if (this.formInline.FactoryTime) {
      //   if (this.formInline.FactoryTime.length > 0) {
      //     startTime = this.formInline.FactoryTime[0]
      //     endTime = this.formInline.FactoryTime[1]
      //   }
      // }
      let param = {
        companyId: sessionStorage.getItem("companyId"),
        orgId: this.id,
        selectCarType: this.formInline.selectCarType,
        selectCarValue: this.formInline.selectCarValue,
        terminalId: this.formInline.terminalId,
        // startTime: startTime,
        // endTime: endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$store.dispatch('VideoPreview/GET_SELECTCARVIDEOPREVIEWLIST', param).then(res => {
        if (res) {
          console.log(res)
          if (res.data.code == 200) {
            this.list = res.data.data.list
            // res.data.data.list.map(item => {
            //   let itemList = JSON.stringify(item.safeList)
            //   let result = itemList.replace(/""/g, "null")
            //   item.safeList = JSON.parse(result)
            // })
            this.$refs.page.CommandTotal = res.data.data.total
          }
        }
      }).catch(err => { })
    },
    onSearch() {
      this.$refs.page.CommandCurrentPage = 1
      this.currentPage = 1
      this.getAllCar()
    },
    onClear() {
      this.formInline = {
        selectCarType: '',
        selectCarValue: '',
        terminalId: '',
        // FactoryTime: [],
      }
      this.getAllCar()
    },
    handleClick(tab, event) {
      console.log('切换标签页:', tab, event);
      // 切换摄像头时，停止当前播放并重置状态
      if (this.dialogFormVisible && this.currentCarInfo) {
        this.stopVideo();
        this.videoStreamUrl = ''; // 重置视频流URL，显示播放按钮
      }
    },
    startPlayVideo() {
      // 点击播放按钮，启动视频流
      if (!this.videoStreamUrl && this.currentCarInfo) {
        // 还没有视频流URL，先获取视频流
        this.startLiveVideoStream();
      } else if (this.videoStreamUrl) {
        // 已经有视频流URL，开始播放
        this.startPlayAfterInit();
      }
    },
    startPlayAfterInit() {
      // 播放器初始化后开始播放
      this.$nextTick(() => {
        // 如果是FLV播放器
        if (this.flvPlayer) {
          try {
            const videoElement = document.getElementById('live-video-player');
            if (videoElement) {
              videoElement.play().then(() => {
                console.log('✓ FLV 视频开始播放');
                this.isPlaying = true;
                this.isPaused = false;
              }).catch(error => {
                console.error('FLV播放失败:', error);
                this.$message.error('视频播放失败');
              });
            }
          } catch (error) {
            console.error('FLV播放异常:', error);
            this.$message.error('视频播放异常');
          }
        }
        // 如果是video.js播放器
        else if (this.videoPlayer) {
          this.videoPlayer.play().then(() => {
            console.log('video.js 视频开始播放');
            this.isPlaying = true;
            this.isPaused = false;
          }).catch(error => {
            console.error('video.js播放失败:', error);
            this.$message.error('视频播放失败');
          });
        }
      });
    },
    togglePlayPause() {
      // 切换播放/暂停状态
      this.$nextTick(() => {
        // 如果是FLV播放器
        if (this.flvPlayer) {
          const videoElement = document.getElementById('live-video-player');
          if (videoElement) {
            if (videoElement.paused) {
              // 当前是暂停状态，点击后播放当前时间实时视频（跳转到直播边缘）
              this.seekToLiveEdge(videoElement);
              videoElement.play().then(() => {
                console.log('✓ FLV 视频继续播放当前时间实时视频');
                this.isPaused = false;
              }).catch(error => {
                console.error('FLV播放失败:', error);
              });
            } else {
              // 当前是播放状态，点击后暂停
              videoElement.pause();
              console.log('FLV 视频暂停');
              this.isPaused = true;
            }
          }
        }
        // 如果是video.js播放器
        else if (this.videoPlayer) {
          if (this.videoPlayer.paused()) {
            // 当前是暂停状态，点击后播放当前时间实时视频（跳转到直播边缘）
            const techEl = this.videoPlayer.tech_ && this.videoPlayer.tech_.el ? this.videoPlayer.tech_.el() : null
            this.seekToLiveEdge(techEl || this.videoPlayer.el().querySelector('video'))
            this.videoPlayer.play().then(() => {
              console.log('video.js 视频继续播放当前时间实时视频');
              this.isPaused = false;
            }).catch(error => {
              console.error('video.js播放失败:', error);
            });
          } else {
            // 当前是播放状态，点击后暂停
            this.videoPlayer.pause();
            console.log('video.js 视频暂停');
            this.isPaused = true;
          }
        }
      });
    },
    // 跳转到直播边缘，播放当前时间的实时视频
    seekToLiveEdge(videoElement) {
      if (!videoElement) return
      try {
        if (videoElement.buffered && videoElement.buffered.length > 0) {
          const liveEdge = videoElement.buffered.end(videoElement.buffered.length - 1) - 0.1
          if (liveEdge > videoElement.currentTime) {
            videoElement.currentTime = liveEdge
            console.log('已跳转到直播边缘播放当前时间实时视频:', liveEdge)
          }
        }
      } catch (e) {
        console.warn('跳转到直播边缘失败:', e)
      }
    },
    submitForm() {
      this.stopVideo();
      this.stopLiveVideoStream();
      // 立即重置状态，不等待后端响应
      this.videoStreamUrl = '';
      this.isPlaying = false;
      this.isPaused = false;
      this.showPlayButton = false;
      this.dialogFormVisible = false;
    },
    cancle() {
      this.stopVideo();
      this.stopLiveVideoStream();
      // 立即重置状态，不等待后端响应
      this.videoStreamUrl = '';
      this.isPlaying = false;
      this.isPaused = false;
      this.showPlayButton = false;
      this.dialogFormVisible = false;
    },
    closeDia(done) {
      this.stopVideo();
      this.stopLiveVideoStream();
      // 立即重置状态，不等待后端响应
      this.videoStreamUrl = '';
      this.isPlaying = false;
      this.isPaused = false;
      this.showPlayButton = false;
      // 调用done()才能真正关闭弹框
      if (done) {
        done();
      }
      this.dialogFormVisible = false;
    },
    stopVideo() {
      // 停止视频播放并重置状态
      if (this.videoPlayer) {
        try {
          this.videoPlayer.pause();
          this.videoPlayer.dispose();  // 销毁video.js播放器实例
          console.log('停止并销毁video.js播放器');
        } catch (error) {
          console.error('停止video.js播放器失败:', error);
        }
        this.videoPlayer = null;
      }
      if (this.flvPlayer) {
        try {
          this.flvPlayer.pause();
          this.flvPlayer.unload();
          this.flvPlayer.detachMediaElement();
          this.flvPlayer.destroy();
          console.log('停止并销毁flv.js播放器');
        } catch (error) {
          console.error('停止flv.js播放器失败:', error);
        }
        this.flvPlayer = null;
      }
      this.isPlaying = false;
      this.isPaused = false;
      this.showPlayButton = false;
    },

    // submitTransferForm(TransferFormName) {
    //   this.$refs[TransferFormName].validate((valid) => {
    //     if (valid) {
    //       let carIds = ''
    //       this.selected.map((item, index) => {
    //         if (index == 0) {
    //           carIds = item.carId
    //         } else {
    //           carIds = carIds + ',' + item.carId
    //         }
    //       })
    //       let param = {
    //         carIds: carIds,
    //         orgId: this.roleId
    //       }
    //       this.$store.dispatch('VehicleFiles/GET_BATCHCAR', param).then(res => {
    //         if (res.data.code == 200) {
    //           this.$message.success(this.$t('common.btn.transferSuccess'))
    //           this.dialogTransferFormVisible = false;
    //           this.getAllCar();
    //           this.closeTransfer();
    //         } else {
    //           this.$message.error(res.data.msg)
    //         }

    //       }).catch(err => { })
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // cancleTransfer(TransferFormName) {
    //   this.dialogTransferFormVisible = false;
    //   this.TransferForm = {
    //     carId: '',
    //     roleId: ''
    //   }
    // },
    // closeTransferDia() {
    //   this.TransferForm = {
    //     carId: '',
    //     roleId: ''
    //   }
    //   this.dialogTransferFormVisible = false;
    // },

    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getAllCar();
    },
    onResize: function (x, y, width, height) {
      let box = document.getElementById("leftBox");
      box.style.width = width + "px";
    },
    startLiveVideoStream() {
      if (!this.currentCarInfo || !this.currentCarInfo.carId) {
        this.$message.error(this.$t('common.noData'))
        return
      }

      let param = {
        carId: this.currentCarInfo.carId,
        channelNo: this.activeName
      }
      // this.videoStreamUrl = "https://pull-demo.volcfcdnrd.com/live/st-4536521.flv"
      // this.$nextTick(() => {
      //   this.initVideoPlayer()
      // })

      console.log('启动实时视频，参数:', param)

      this.$store.dispatch('VideoPreview/GET_STARTLIVEVIDEO', param).then(res => {
        console.log('启动实时视频响应:', res)
        if (res && res.data.code == 200) {
          console.log('视频流数据:', res.data.data)
          this.videoStreamUrl = res.data.data.videoPath
          console.log('视频流URL:', this.videoStreamUrl)
          console.log('视频类型:', this.getVideoType(this.videoStreamUrl))

          this.$nextTick(() => {
            this.initVideoPlayer()
            // 初始化播放器后，等待一小段时间再开始播放（给播放器一些时间准备）
            setTimeout(() => {
              this.startPlayAfterInit();
            }, 300);
          })
        } else {
          this.$message.error(res.data.msg || this.$t('common.getError'))
        }
      }).catch(err => {
        this.$message.error(this.$t('common.getError'))
        console.error('启动实时视频失败:', err)
      })
    },
    stopLiveVideoStream() {
      if (!this.currentCarInfo || !this.currentCarInfo.carId) {
        return
      }
      let param = {
        carId: this.currentCarInfo.carId,
        channelNo: this.activeName
      }
      this.$store.dispatch('VideoPreview/GET_STOPLIVEVIDEO', param).then(res => {
        if (res && res.data.code == 200) {
          console.log('后端停止视频流成功')
          // 不在这里重置状态，由调用方（submitForm/cancle/closeDia）统一处理
        } else {
          console.warn('后端停止视频流返回异常:', res.data.msg)
        }
      }).catch(err => {
        console.error('停止实时视频失败:', err)
        // 即使接口调用失败，也要继续执行本地清理
      })
    },
    // 动态加载 flv.js
    loadFlvJs() {
      return new Promise((resolve, reject) => {
        // 检查是否已经加载
        if (window.flvjs) {
          console.log('flv.js 已存在，直接使用');
          this.isFlvJsLoaded = true;
          resolve(window.flvjs);
          return;
        }
        console.log('开始从 CDN 加载 flv.js...');
        // 创建 script 标签
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/flv.js@1.6.2/dist/flv.min.js';
        script.async = true;
        script.onload = () => {
          console.log('✓ flv.js 从 CDN 加载成功', window.flvjs);
          resolve(window.flvjs);
        };

        script.onerror = (error) => {
          console.error('✗ flv.js 加载失败', error);
          reject(new Error('Failed to load flv.js from CDN'));
        };

        document.head.appendChild(script);
      });
    },

    initVideoPlayer() {
      if (!this.videoStreamUrl) {
        console.warn('视频流URL为空，无法初始化播放器')
        return
      }

      const videoContainer = document.getElementById('video-player-container')
      if (!videoContainer) {
        console.error('视频容器未找到')
        return
      }

      const videoType = this.getVideoType(this.videoStreamUrl)
      console.log('初始化视频播放器 - URL:', this.videoStreamUrl, '类型:', videoType)

      // 如果是 FLV 格式，使用 flv.js 播放
      if (videoType === 'video/x-flv' || this.videoStreamUrl.endsWith('.flv')) {
        console.log('检测到 FLV 格式，准备加载 flv.js...')

        // 清空容器，显示加载提示
        videoContainer.innerHTML = `
          <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; background: #000; color: #fff;">
            <div style="text-align: center;">
              <div style="font-size: 48px; margin-bottom: 20px;">⏳</div>
              <div style="font-size: 16px;">正在加载 FLV 播放器...</div>
              <div style="font-size: 12px; color: #999; margin-top: 10px;">首次加载可能需要几秒</div>
            </div>
          </div>
        `

        // 动态加载 flv.js
        this.loadFlvJs().then((flvjs) => {
          console.log('flv.js 已加载，版本:', flvjs.version)
          console.log('浏览器支持检查:', flvjs.isSupported())

          // 重新设置 video 元素（移除controls属性，隐藏默认控制条）
          videoContainer.innerHTML = `
            <video 
              id="live-video-player" 
              style="width: 100%; height: 100%; background: #000; object-fit: contain;"
              preload="auto"
            ></video>
          `

          this.$nextTick(() => {
            const videoElement = document.getElementById('live-video-player')
            if (videoElement) {
              // 检查浏览器是否支持 MediaSource（flv.js 需要）
              if (!flvjs.isSupported()) {
                console.error('浏览器不支持 flv.js')
                videoContainer.innerHTML = `
                  <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #000; color: #fff; padding: 20px;">
                    <div style="font-size: 48px; margin-bottom: 20px;">❌</div>
                    <div style="font-size: 18px; font-weight: bold; margin-bottom: 15px; color: #F56C6C;">浏览器不支持</div>
                    <p>当前浏览器不支持 FLV 播放</p>
                    <p style="color: #909399; font-size: 12px; margin-top: 10px;">请使用 Chrome、Firefox 或 Edge 浏览器</p>
                  </div>
                `
                this.$message.error('当前浏览器不支持 FLV 播放，请使用 Chrome、Firefox 或 Edge 浏览器')
                return
              }

              // 销毁旧的 flv 播放器实例
              if (this.flvPlayer) {
                try {
                  this.flvPlayer.pause()
                  this.flvPlayer.unload()
                  this.flvPlayer.detachMediaElement()
                  this.flvPlayer.destroy()
                } catch (e) {
                  console.error('销毁旧 flv 播放器失败:', e)
                }
                this.flvPlayer = null
              }

              console.log('创建 flv.js 播放器实例')

              try {
                // 创建 flv.js 播放器
                this.flvPlayer = flvjs.createPlayer({
                  type: 'flv',
                  url: this.videoStreamUrl,
                  isLive: true,
                  hasAudio: false,
                  hasVideo: true,
                  cors: true
                }, {
                  enableWorker: false, // 先禁用 Worker，避免兼容性问题
                  enableStashBuffer: false,
                  stashInitialSize: 128,
                  lazyLoad: false,
                  seekType: 'range',
                  autoCleanupSourceBuffer: true
                })

                console.log('flv.js 播放器配置完成')

                // 附加到 video 元素
                this.flvPlayer.attachMediaElement(videoElement)

                // 加载视频
                this.flvPlayer.load()

                console.log('FLV 视频已加载')

                // 监听元数据加载
                this.flvPlayer.on(flvjs.Events.METADATA_ARRIVED, (metadata) => {
                  console.log('✓ FLV 元数据加载完成')
                })

                // 监听统计信息
                this.flvPlayer.on(flvjs.Events.STATISTICS_INFO, (stats) => {
                  console.log('FLV 统计信息:', stats)
                })

                // 监听错误
                this.flvPlayer.on(flvjs.Events.ERROR, (errorType, errorDetail, errorInfo) => {
                  console.error('✗ FLV 播放错误:', errorType, errorDetail, errorInfo)

                  let errorMsg = 'FLV 播放失败'
                  switch (errorType) {
                    case flvjs.ErrorTypes.NETWORK_ERROR:
                      errorMsg = '网络错误，无法连接视频流'
                      break
                    case flvjs.ErrorTypes.MEDIA_ERROR:
                      errorMsg = '媒体错误，视频格式不支持或损坏'
                      break
                    case flvjs.ErrorTypes.OTHER_ERROR:
                      errorMsg = '其他错误: ' + errorDetail
                      break
                  }
                  this.$message.error(errorMsg)
                })

                // 不在这里自动播放，等待用户点击播放按钮
                console.log('✓ FLV 播放器已就绪，等待用户点击播放按钮')
              } catch (error) {
                console.error('创建 flv.js 播放器失败:', error)
                this.$message.error('FLV 播放器初始化失败：' + error.message)

                videoContainer.innerHTML = `
                  <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #000; color: #fff; padding: 20px;">
                    <div style="font-size: 48px; margin-bottom: 20px;">❌</div>
                    <div style="font-size: 18px; font-weight: bold; margin-bottom: 15px; color: #F56C6C;">播放器初始化失败</div>
                    <p>${error.message}</p>
                  </div>
                `
              }
            }
          })
        }).catch(error => {
          console.error('加载 flv.js 失败:', error)
          this.$message.error('FLV 播放器加载失败，请刷新页面重试')

          // 显示错误提示
          videoContainer.innerHTML = `
            <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #000; color: #fff; padding: 20px;">
              <div style="font-size: 48px; margin-bottom: 20px;">❌</div>
              <div style="font-size: 18px; font-weight: bold; margin-bottom: 15px; color: #F56C6C;">FLV 播放器加载失败</div>
              <div style="font-size: 14px; line-height: 1.8; text-align: center; max-width: 600px;">
                <p style="margin-bottom: 10px;">无法从 CDN 加载 FLV 播放器组件。</p>
                <p style="margin-bottom: 10px; color: #67C23A;"><strong>建议方案：</strong></p>
                <p>请联系后端开发人员将实时视频流转换为 <strong>HLS (m3u8)</strong> 格式</p>
                <p style="color: #909399; font-size: 12px; margin-top: 15px;">或检查网络连接后刷新页面重试</p>
              </div>
            </div>
          `
        })

        return
      }

      // 非 FLV 格式，使用 video.js
      videoContainer.innerHTML = `
        <video id="live-video-player" class="video-js vjs-default-skin vjs-big-play-centered" preload="auto" style="width: 100%; height: 100%;"></video>
      `

      this.$nextTick(() => {
        const videoElement = document.getElementById('live-video-player')
        if (videoElement) {
          if (this.videoPlayer) {
            try {
              this.videoPlayer.dispose()
            } catch (e) {
              console.error('销毁旧播放器失败:', e)
            }
          }

          const playerOptions = {
            autoplay: false,
            controls: false,  // 隐藏默认控制条
            preload: 'auto',
            fluid: true,
            language: 'zh-CN',
            playbackRates: [0.5, 1, 1.25, 1.5, 2],
            sources: [{
              src: this.videoStreamUrl,
              type: videoType
            }],
            html5: {
              vhs: {
                overrideNative: true
              }
            },
            controlBar: {
              children: []  // 移除所有控制条组件
            }
          }

          console.log('播放器配置:', playerOptions)

          this.videoPlayer = videojs('live-video-player', playerOptions, function onPlayerReady() {
            console.log('video.js 播放器已就绪')
            // 不在这里自动播放，等待用户点击播放按钮
            console.log('✓ video.js 播放器已就绪，等待用户点击播放按钮')
          })

          // 添加错误处理
          if (this.videoPlayer && this.videoPlayer.error()) {
            const error = this.videoPlayer.error()
            console.error('创建 video.js 播放器失败:', error)
            this.$message.error('video.js 播放器初始化失败：' + error.message)
          }

          this.videoPlayer.on('loadedmetadata', () => {
            console.log('视频元数据加载完成')
          })

          this.videoPlayer.on('play', () => {
            console.log('视频开始播放')
            this.isPlaying = true;
            this.isPaused = false;
          })

          this.videoPlayer.on('pause', () => {
            console.log('视频暂停')
            this.isPaused = true;
          })

          this.videoPlayer.on('error', (error) => {
            const errorCode = this.videoPlayer.error()
            console.error('视频播放错误:', error)
            console.error('错误代码:', errorCode ? errorCode.code : 'unknown')
            console.error('错误消息:', errorCode ? errorCode.message : 'unknown')

            let errorMsg = '视频播放失败'
            if (errorCode) {
              switch (errorCode.code) {
                case 1:
                  errorMsg = '视频加载被中止'
                  break
                case 2:
                  errorMsg = '网络错误，视频加载失败'
                  break
                case 3:
                  errorMsg = '视频解码失败，格式不支持'
                  break
                case 4:
                  errorMsg = '视频格式不支持或文件损坏'
                  break
                default:
                  errorMsg = '视频播放失败，请检查视频流地址'
              }
            }
            this.$message.error(errorMsg)
          })

          this.videoPlayer.on('waiting', () => {
            console.log('视频缓冲中...')
          })

          this.videoPlayer.on('ended', () => {
            console.log('视频播放结束')
          })
        }
      })
    },
    destroyVideoPlayer() {
      // 销毁 flv.js 播放器实例
      if (this.flvPlayer) {
        try {
          this.flvPlayer.pause()
          this.flvPlayer.unload()
          this.flvPlayer.detachMediaElement()
          this.flvPlayer.destroy()
          console.log('flv.js 播放器已销毁')
        } catch (e) {
          console.error('销毁 flv 播放器失败:', e)
        }
        this.flvPlayer = null
      }

      // 销毁 video.js 播放器实例
      if (this.videoPlayer) {
        try {
          this.videoPlayer.pause()
          this.videoPlayer.dispose()
          console.log('video.js 播放器已销毁')
        } catch (e) {
          console.error('销毁 video.js 播放器失败:', e)
        }
        this.videoPlayer = null
      }

      const videoContainer = document.getElementById('video-player-container')
      if (videoContainer) {
        videoContainer.innerHTML = ''
      }

      this.videoStreamUrl = ''
    },
    getVideoType(url) {
      // 根据视频URL判断视频类型
      if (!url) return 'application/x-mpegURL'

      const extension = url.split('?')[0].split('.').pop().toLowerCase()

      switch (extension) {
        case 'm3u8':
          return 'application/x-mpegURL' // HLS
        case 'mp4':
          return 'video/mp4'
        case 'webm':
          return 'video/webm'
        case 'ogg':
          return 'video/ogg'
        case 'flv':
          return 'video/x-flv'
        case 'rtmp':
          return 'rtmp/flv'
        case 'rtsp':
          return 'rtsp'
        default:
          // 如果无法识别，默认返回 HLS 格式（常用于直播流）
          return 'application/x-mpegURL'
      }
    },
  }
}